import { render, staticRenderFns } from "./index.vue?vue&type=template&id=448720f7&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Server\\domains\\localhost\\ss\\wa-apps\\shop\\plugins\\giftcertificates\\build\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('448720f7')) {
      api.createRecord('448720f7', component.options)
    } else {
      api.reload('448720f7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=448720f7&", function () {
      api.rerender('448720f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/pages/frontend_form/index.vue"
export default component.exports